import { useQuery } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";
import handleError from "@lib/helpers/handleError";
import { RECRUITER_KEYS } from "./keys";
import type { RecruiterSettings } from "./types";

/**
 * The authenticated recruiter's account settings.
 *
 * Kept on the same caching options as useRecruiterDetails on purpose: the
 * Settings dialog merges both payloads and re-syncs its local state whenever
 * either changes, so a query that went stale on its own schedule would refetch
 * alone and reset the form mid-edit.
 */
export default function useRecruiterSettings() {
  const api = useAxios();
  const { data, error, isLoading } = useQuery({
    queryKey: RECRUITER_KEYS.settings(),
    queryFn: () => api.get<RecruiterSettings>("/me/settings"),
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 5 * 60_000,
  });

  handleError(error);

  return { settings: data?.data, isLoading };
}
